import { UserData, UserEmailData } from "../../../pages/login/types/user-data.interface";
import { action, ActionType } from "typesafe-actions";
import { AuthToken } from "../types/auth-token.interface";
import { User } from "../types/user.interface";

export enum UserActions {
  Login = "User/Login",
  LoginSuccess = "User/LoginSuccess",
  Logout = "User/Logout",
  ValidateCredentials = "User/ValidateCredentials",
  ValidateCredentialsSuccess = "User/ValidateCredentialsSuccess",
  SetUser = "User/SetUser",
  LoadingUser = "User/Loading",
  FetchUserData = "User/FetchUserData",
  FetchUserDataSuccess = "User/FetchUserDataSuccess",
  FetchAccessToken = "User/FetchAccessToken",
  FetchAccessTokenSuccess = "User/FetchAccessTokenSuccess",
  Reset = "User/Reset",
  ResetPasswordRequest = "User/ResetPasswordRequest",
  ValidateResetPasswordRequestCredential = "User/ValidateResetPasswordRequestCredential",
  ValidateResetPasswordRequestCredentialSuccess = "User/ValidateResetPasswordRequestCredentialSuccess",
  SendResetPasswordRequest = "User/SendResetPasswordRequest",
  SendResetPasswordRequestSuccess = "User/SendResetPasswordRequestSuccess",
}

export const fetchAccessToken = (userData: UserData) =>
  action(UserActions.FetchAccessToken, userData);

export const fetchAccessTokenSuccess = (token: AuthToken) =>
  action(UserActions.FetchAccessTokenSuccess, token);

export const fetchUserData = (userId: number) => action(UserActions.FetchUserData, userId);

export const fetchUserDataSuccess = (user: User) => action(UserActions.FetchUserDataSuccess, user);

export const setUser = (user: User) => action(UserActions.SetUser, user);

export const loadingUser = () => action(UserActions.LoadingUser);
export const login = (userData: UserData) => action(UserActions.Login, userData);

export const logout = () => action(UserActions.Logout);

export const loginSuccess = () => action(UserActions.LoginSuccess);

export const validateCredentials = (userData: UserData) =>
  action(UserActions.ValidateCredentials, userData);

export const validateCredentialsSuccess = (userData: UserData) =>
  action(UserActions.ValidateCredentialsSuccess, userData);

export const reset = () => action(UserActions.Reset);

export const resetPasswordRequest = (userEmailData: UserEmailData) =>
  action(UserActions.ResetPasswordRequest, userEmailData);

export const validateResetPasswordRequestCredential = (userEmailData: UserEmailData) =>
  action(UserActions.ValidateResetPasswordRequestCredential, userEmailData);

export const validateResetPasswordRequestCredentialSuccess = (userEmailData: UserEmailData) =>
  action(UserActions.ValidateResetPasswordRequestCredentialSuccess, userEmailData);

export const sendResetPasswordRequest = (userEmailData: UserEmailData) =>
  action(UserActions.SendResetPasswordRequest, userEmailData);

export const sendResetPasswordRequestSuccess = () =>
  action(UserActions.SendResetPasswordRequestSuccess);

const actionCreators = {
  login,
  logout,
  loginSuccess,
  validateCredentials,
  validateCredentialsSuccess,
  fetchAccessToken,
  fetchAccessTokenSuccess,
  loadingUser,
  setUser,
  fetchUserData,
  fetchUserDataSuccess,
  reset,
  resetPasswordRequest,
  validateResetPasswordRequestCredential,
  validateResetPasswordRequestCredentialSuccess,
  sendResetPasswordRequest,
  sendResetPasswordRequestSuccess,
};

export type UserActionsType = ActionType<typeof actionCreators>;
